import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("ApiKeysStore");

const urls = {
  create: "/bulwark/api-key/merchant/create",
  list: "/bulwark/api-key/merchant/list",
  delete: (apiKeyId) => `/bulwark/api-key/merchant/delete/${apiKeyId}`,
  merchantUpdateWebhookUrl: "/merchant/merchant/webhook-url/merchant",
};

const initState = () => {
  return {
    apiKeys: [],
  };
};

const actions = {
  fetchList: async ({ commit }) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.list);
      commit("saveList", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  create: async ({}, request) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.post(urls.create, request);
      return data.apiKey;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  delete: async (_, apiKeyId) => {
    try {
      const axios = await network.connection();
      await axios.delete(urls.delete(apiKeyId));
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  getWebhookUrl: async ({}) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.merchantUpdateWebhookUrl);
      return data.webhookUrl;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  updateWebhookUrl: async ({}, { webhookUrl: webhookUrl }) => {
    try {
      const axios = await network.connection();
      await axios.patch(urls.merchantUpdateWebhookUrl, {
        webhookUrl: webhookUrl,
      });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveList: (state, data) => {
    state.apiKeys = data;
  },
};

const getters = {
  list: (state) => {
    return state.apiKeys;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
